import { useEffect } from 'react';

export default function useMyAskAi () {

  useEffect(() => {
    const myAskAiScript = document.createElement('script');
    myAskAiScript.dataset.name = 'my-ask-ai';
    myAskAiScript.type = 'text/javascript';
    myAskAiScript.src = 'https://myaskai.com/api/1.1/wf/embed-v2?i=2ctM91EZ4gN10CaOqbATSG2rdlNc0T';
    myAskAiScript.id = '2ctM91EZ4gN10CaOqbATSG2rdlNc0T';
    myAskAiScript.defer = true;
    document.head.appendChild(myAskAiScript);
    return () => document.head.removeChild(myAskAiScript);

  },[])
}